module.exports = __webpack_public_path__ + "img/overview_blaupause.9d3b3174.gif";